/**
 * Feature flags for the front-end. Flip these back once the underlying
 * integration is fixed — see the TODO/comment on each flag.
 */

// TODO: Re-enable once Resend sender domain (getwherewasi.com) is fully
// verified in the Resend dashboard (SPF/DKIM/DMARC records) OR SENDER_EMAIL
// is switched to a verified fallback. When this is true, the card bell,
// CardEditModal nudge toggle, and Settings › Send my nudges to controls
// all become interactive again. When false, they degrade to a calm
// "coming soon" message so users don't tap into a broken flow.
export const EMAIL_NUDGES_ENABLED = false;
